import React from 'react';

function SearchFilters({ searchTerm, setSearchTerm, selectedStatus, setSelectedStatus }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
      <div className="bg-slate-50 rounded-lg border border-slate-200 p-5">
        <div className="flex flex-col md:flex-row gap-4 items-center">
          <div className="flex-1 relative w-full">
            <i className="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="text"
              placeholder="Search by state, country, law name, or category..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            <button
              className={`filter-chip ${selectedStatus === 'all' ? 'active' : ''}`}
              onClick={() => setSelectedStatus('all')}
            >
              All Status
            </button>
            <button
              className={`filter-chip ${selectedStatus === 'active' ? 'active' : ''}`}
              onClick={() => setSelectedStatus('active')}
            >
              Active
            </button>
            <button
              className={`filter-chip ${selectedStatus === 'pending' ? 'active' : ''}`}
              onClick={() => setSelectedStatus('pending')}
            >
              Pending
            </button>
            <button
              className={`filter-chip ${selectedStatus === 'challenged' ? 'active' : ''}`}
              onClick={() => setSelectedStatus('challenged')}
            >
              Challenged
            </button>
            <button
              className={`filter-chip ${selectedStatus === 'blocked' ? 'active' : ''}`}
              onClick={() => setSelectedStatus('blocked')}
            >
              Blocked
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchFilters;
